module.exports = __webpack_public_path__ + "img/14.5a7f8566.jpg";